import { useState, useEffect } from 'react';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: "Premium Driveway",
      subtitle: "Sealcoating",
      description: "Professional asphalt protection that extends your driveway life by 3–5 years",
      image: "/work2.jpg"
    },
    {
      title: "Crack Filling &",
      subtitle: "Repair",
      description: "Stop water damage before it starts — professional crack repair for lasting results",
      image: "/work1.jpg"
    }
  ];

  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {slides.map((slide, index) => (
        <div key={index} className={`absolute inset-0 transition-opacity duration-1000 ${currentSlide === index ? 'opacity-100' : 'opacity-0'}`}>
          <div className="w-full h-full bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url('${slide.image}')` }} />
          <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/65 to-black/90" />
        </div>
      ))}

      <div className="absolute top-0 left-0 right-0 h-1 bg-orange-500 z-20" />

      <nav className="absolute top-0 left-0 right-0 z-20 px-6 py-4 flex items-center justify-end">
        <a href="tel:262-215-0688" className="hidden sm:flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-5 py-2.5 rounded font-semibold text-sm transition-all duration-200">
          <i className="ri-phone-fill"></i>(262) 215-0688
        </a>
      </nav>

      <div className={`relative z-10 text-center text-white px-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <div className="max-w-4xl mx-auto">

          {/* Logo — centered, large, crisp */}
          <div className="flex justify-center mb-6 mt-16">
            <img
              src="/logo.png"
              alt="Lakes Area Sealcoating"
              className="w-64 md:w-96 lg:w-[480px] drop-shadow-2xl"
            />
          </div>

          <div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-500/40 text-orange-300 text-sm font-semibold px-4 py-2 rounded-full mb-8 uppercase tracking-widest">
            <i className="ri-shield-check-line"></i>
            Licensed & Insured · Walworth County, WI
          </div>

          <div className="min-h-[110px] mb-8 flex flex-col items-center justify-center">
            <h1 className="font-display text-5xl md:text-7xl font-bold leading-none mb-4 uppercase tracking-tight">
              {slides[currentSlide].title}{' '}
              <span className="text-orange-500">{slides[currentSlide].subtitle}</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-300 max-w-2xl">{slides[currentSlide].description}</p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <a href="tel:262-215-0688" className="flex items-center gap-3 bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded font-bold text-lg transition-all duration-200 shadow-lg shadow-orange-500/30">
              <i className="ri-phone-fill text-xl"></i> Call Now: (262) 215-0688
            </a>
            <a href="#contact" className="flex items-center gap-3 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white px-8 py-4 rounded font-bold text-lg transition-all duration-200 border border-white/20">
              <i className="ri-calculator-line text-xl"></i> Get Free Estimate
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400">
            {['100+ Driveways Sealed', '99% Satisfaction', '7-Day Availability', 'Free Estimates'].map((t, i) => (
              <div key={i} className="flex items-center gap-2"><i className="ri-check-line text-orange-500"></i>{t}</div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-16 left-1/2 -translate-x-1/2 flex space-x-2 z-10">
        {slides.map((_, index) => (
          <button key={index} onClick={() => setCurrentSlide(index)}
            className={`h-1 rounded-full transition-all duration-300 ${currentSlide === index ? 'bg-orange-500 w-8' : 'bg-white/30 w-4'}`}
          />
        ))}
      </div>
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce z-10">
        <i className="ri-arrow-down-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}
